// extracted by mini-css-extract-plugin
module.exports = {"scoreCard":"style-module__scoreCard___2uM54"};